export const customPostHooks = {
  redirectToSelfService: (store) => {
    store.dispatch('auth/logout', true, { root: true });
  },
};
